/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../../utilities/Tools";
import { Ajax } from "../../core/Ajax";

class Autocomplete {
  constructor(input, settings = {}) {
    this._relatedInput = null;
    this.filterInput = input;
    this._filterInputValue = this.filterInput.value;
    this.settings = Object.assign(
      {
        autocompleteSource: undefined, // id pola input, którego wartość jest przesyłana w formularzu. Pole przyjmuje wartość po wyborze z listy autocomplete
        autocompleteSourceType: "", // "function", "url"
        autocompleteMinLength: 3, //
        autocompleteElementFullName: "", //
      },
      Tools.parseStringValuesInObjectLiteral(
        (({ dataset }) => {
          const datasetObject = Object.assign({}, dataset);

          delete datasetObject.toggle;
          return datasetObject;
        })(input)
      ),
      Tools.parseStringValuesInObjectLiteral(settings)
    );
    this._data = null;
    this.timeout = undefined;
    this.closeBind = this.close.bind(this);
    this.clearFilterInputOnChangeBind = this.clearFilterInputOnChange.bind(
      this
    );

    // Inicjalizacja
    this.init();
  }

  get relatedInput() {
    return this._relatedInput;
  }

  set relatedInput(value) {
    this._relatedInput = value;
  }

  get filterInputValue() {
    return this._filterInputValue;
  }

  set filterInputValue(value) {
    this._filterInputValue = value;
  }

  get data() {
    return this._data;
  }

  set data(value) {
    this._data = value;
  }

  events() {
    const _this = this;

    this.filterInput.addEventListener(
      "keyup",
      function (event) {
        let filterInput = this;

        // Debounce - ograniczenie wysyłki żądania Ajax.
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          _this.listener(event, filterInput.value);
        }, 500);
      },
      false
    );

    this.filterInput.addEventListener(
      "change",
      function (event) {
        _this.listener(event);
      },
      false
    );

    this.filterInput.addEventListener(
      "click",
      function (event) {
        // Przerywa propagowanie zdarzenie click (funkcja clickingOutsideAutocompleteEvent() nie zostanie wykonana).
        event.stopPropagation();
      },
      false
    );

    this.filterInput.nextElementSibling.addEventListener(
      "click",
      function (event) {
        // Przerywa propagowanie zdarzenie click (funkcja clickingOutsideAutocompleteEvent() nie zostanie wykonana).
        event.stopPropagation();

        let item = event.target.closest(".autocomplete__item");

        if (item) {
          switch (_this.settings.autocompleteSourceType) {
            case "function":
              _this.select(
                _this.data[item.dataset.index].id,
                _this.data[item.dataset.index].label
              );

              break;

            case "url":
              _this.select(
                _this.data[item.dataset.index].id,
                _this.data[item.dataset.index].label,
                _this.data[item.dataset.index].datafields
              );

              break;
          }
        }
      },
      false
    );
  }

  listener(event, ...param) {
    const _this = this;
    let value = null;

    switch (event.type) {
      case "keyup":
        value = param[0];

        if (value.length >= this.settings.autocompleteMinLength) {
          if (this.filterInputValue !== value) {
            this.filterInputValue = value;

            switch (this.settings.autocompleteSourceType) {
              case "function":
                this.settings.autocompleteSource(
                  { term: this.filterInputValue },
                  function (json) {
                    // Zapisanie json
                    _this.data = json;

                    // Wyrenderowanie listy.
                    _this.renderDropdownAutocompleteList(json);
                  }
                );
                break;

              case "url":
                let url = this.settings.autocompleteSource;

                if (value) {
                  let urlSearchParamsString = new URLSearchParams({
                    term: value,
                  }).toString();

                  url += `&${urlSearchParamsString}`;
                }

                // Wysłanie żądania Ajax
                Ajax.sendAjaxRequest(url)
                  .then((json) => {
                    // Zapisanie json
                    this.data = json;

                    // Wyrenderowanie listy.
                    this.renderDropdownAutocompleteList(json);
                  })
                  .catch((e) => console.log(e));
                break;
            }
          }
        } else {
          this.filterInputValue = "";
          this.close();
        }

        break;

      case "change":
        document.addEventListener("click", this.clearFilterInputOnChangeBind);
        break;
    }
  }

  // Podkreślenie etykiety przy filtrowaniu
  markLabelOfMatchedOption(label) {
    let regExp = new RegExp(this.filterInputValue, "gi");

    return Boolean(regExp.exec(label))
      ? label.replaceAll(
          regExp,
          `<mark class="p-0 bg-warning">${label.match(regExp)[0]}</mark>`
        )
      : label;
  }

  renderDropdownAutocomplete() {
    this.filterInput.insertAdjacentHTML(
      "afterend",
      (function () {
        return `<div class="autocomplete"></div>`;
      })()
    );
  }

  renderDropdownAutocompleteList(items) {
    const _this = this;

    let autocomplete = this.filterInput.nextElementSibling;

    if (items.length > 0) {
      autocomplete.innerHTML = `<div class="autocomplete__body"><ul class="autocomplete__items">${(function () {
        return items
          .map(function (item, index) {
            return `<li class="autocomplete__item" data-index="${index}" title="${item.label}"><span class="dropdown-item text-truncate">${_this.markLabelOfMatchedOption(item.label)}</span></li>`;
          })
          .join("");
      })()}</ul></div>`;

      // Dodanie zdarzenia pozwalającego na zamknięcie autocomplete.
      document.addEventListener("click", this.closeBind, false);
    } else {
      autocomplete.innerHTML = ``;

      // Usunięcie zdarzenia pozwalającego na zamknięcie autocomplete.
      document.removeEventListener("click", this.closeBind, false);
    }
  }

  //
  select(id = null, name = "", datafields = null) {
    //
    this.filterInputValue = name;

    //
    this.filterInput.value = name;

    //
    this.relatedInput.value = id;

    //
    this.close();

    //
    document.removeEventListener("click", this.clearFilterInputOnChangeBind);

    // Wywołanie zdarzenia change w przypadku zmian opcji.
    document
      .getElementById(this.settings.autocompleteElementFullName)
      .dispatchEvent(
        new CustomEvent("iksorisautocompleteselect", {
          bubbles: true,
          detail: {
            id: id,
            name: name,
            datafields: datafields,
          },
        })
      );
  }

  //
  clearFilterInputOnChange() {
    //
    this.filterInputValue = "";

    //
    this.filterInput.value = "";

    //
    this.relatedInput.value = "";

    // Wywołanie zdarzenia change w przypadku zmian opcji.
    document
      .getElementById(this.settings.autocompleteElementFullName)
      .dispatchEvent(
        new CustomEvent("iksorisautocompleteselect", {
          bubbles: true,
          detail: {
            id: null,
            name: "",
            datafields: null,
          },
        })
      );

    //
    document.removeEventListener("click", this.clearFilterInputOnChangeBind);
  }

  // Zamknięcie okna autocomplete
  close() {
    this.renderDropdownAutocompleteList([]);
  }

  // Stworzenie instancji obiektu za pomocą JS.
  static create(input, settings = {}) {
    return new Autocomplete(input, settings);
  }

  init() {
    // Ustawienie pola input potrzebnego do przesłania formularza.
    if (this.settings.hasOwnProperty("autocompleteRelatedInput")) {
      this.relatedInput = document.getElementById(
        this.settings.autocompleteRelatedInput
      );
    } else {
      throw new Error("Nazwa id pola input jest wymagana!");
    }

    // Renderowanie .combobox
    this.renderDropdownAutocomplete();

    // Inicjowanie zdarzeń
    this.events();

    // Utworzenie Map
    iksoris.instances = iksoris.instances || new Map();

    if (
      !Boolean(iksoris.instances.get(this.settings.autocompleteElementFullName))
    ) {
      iksoris.instances.set(this.settings.autocompleteElementFullName, this);
    }
  }
}

export { Autocomplete };
